import { usePointThemeCssVars } from '@chkp/point.hooks.use-point-theme-css-vars';
import { POINT_VARS_TARGET_ID } from '../../style/theme-consts';
import { PointUtils } from '../../utils/point-ds';

/** Writes the Point design tokens onto <body> as CSS custom properties. Renders nothing and wraps
  nothing, so it can sit at the very top of the tree - above the error boundary, which then gets
  the tokens too.

  Mount it exactly once. Targeting <body> is what makes it reach everything: portaled content (MUI
  dialogs, popovers, tooltips) mounts outside the app root, and the error boundary's fallback
  replaces the app subtree entirely - both still inherit from <body>.

  Render it inside <PointTheme> (PointThemeRoot does): outside a provider useTheme() falls back to
  the light tokens, so dark mode would never reach <body>.

  Still a component rather than a plain call because reading the tokens goes through useTheme(),
  and the package's `exports` map blocks importing the token object directly. */
const PointThemeVars = () => {
  const isPoint = PointUtils.usePointDS();
  // An empty id makes the hook's getElementById miss and bail out, so nothing is written when the
  // theme is off.
  usePointThemeCssVars(isPoint ? POINT_VARS_TARGET_ID : '');
  return null;
};

export default PointThemeVars;
